<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import ApiService from "@/services/jobsiteTrackingService";
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loading
  },
  data() {
    return {
      users: null,
      isLoading: false,
      fullPageLoading: false,
      userSearch: "",
      currentPage: 1,
      debounceTimer: null,
      pageSize: 30
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
        ApiService.getUsers(this.userSearch, this.currentPage, this.pageSize).then((response) => {
          this.users = response.data.data;
        })
        .catch((error) => {
          window.console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    editUser(user){
      this.$router.push({ name: 'editUser', params: { userId: user.userId } });
    },
    loadMoreUser(){
      this.currentPage++;
      this.getData();
    },
    debounceSearch(){

      if(this.debounceTimer  != null){
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
          this.isLoading = true;
          this.currentPage = 1;
          if(this.userSearch != "" && this.userSearch != null){
            ApiService.getUsers(this.userSearch).then((response) => {
              this.isLoading = false;
              this.users = response.data.data;
            })
          }else{
            ApiService.getUsers(this.userSearch, this.currentPage, this.pageSize).then((response) => {
              this.isLoading = false;
              this.users = response.data.data;
            })
          }

      }, 500)

    },
  },
  async created () {
    await this.getData();
  },
}
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">      
            <div class="table-responsive">
              <b-form-input 
                id="userSearch" 
                :placeholder="$t('general.searchUser')"
                v-model="userSearch"
                @input="debounceSearch"
                class="mb-3"
                style="max-width:250px;">
              </b-form-input>      
              <table class="table mb-0 table-hover" style="position:relative;">
                <loading :active.sync="isLoading" 
                  :can-cancel="false"
                  color='#f1b44c'
                  :width=70
                  :height=70
                  loader='dots'
                  :is-full-page="fullPageLoading">
                </loading>  
                <thead class="thead-light">
                  <tr>
                    <th>{{$t('general.name')}}</th>
                    <th style="text-align:center;">{{$t('general.role')}}</th>
                    <th style="width:100px; text-align:center;">{{$t('general.edit')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" :key="index">
                    <td><a v-on:click.prevent="editUser(user)" href="#">{{user.displayName}}</a></td>
                    <td style="text-align:center;">{{user.role}}</td>
                    <td style="text-align:center;">
                      <i @click="editUser(user)" style="cursor:pointer;" class="fas fa-pencil-alt text-success mr-1"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="display:flex; justify-content:center;">
              <a @click="loadMoreUser" href="#">{{$t('general.loadMore')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>